module.exports = __webpack_public_path__ + "static/light-bg-logo-d73ce0fc63cf71c19d996671fc68226f.svg";